import { MyrAPIService } from '../../api/myr/myrAPI';
import { deleteAccountSvc } from './sharedAPI.services';
import SupportedLanguageHelper from '../../utils/SupportLanguageHelper';

import { SupportedLanguage } from '../../config/constants/supportedLanguage.enum';
import { ICancelMembershipRequest } from '../cancelMembership/cancelmembershipRequest';
import { MyrAPIEndpoints } from '../../api/myr/myrAPIEndpoints.constant';

const PrivacyLocaleFormat: { [key: string]: string } = Object.freeze({
    'de-DE': 'de',
    'en-UK': 'en',
    'es-ES': 'es',
    'uk-UA': 'uk',
} as const);

export function getServicesMapping() {
    return MyrAPIService.sendRequest(`config/services`, 'GET');
}

export function getServiceRecommendations(clientId: string) {
    return MyrAPIService.sendRequest(`config/services/${clientId}/recommendations`, 'GET');
}

export function getServicesAndConsentsStatus(locale: string) {
    const innerlocale = String(locale || localStorage.getItem('userSetLocale'));
    const lang: SupportedLanguage = SupportedLanguageHelper.getSupportLanguage(innerlocale);
    const langCode = PrivacyLocaleFormat[lang] ?? SupportedLanguage.EN;
    return MyrAPIService.sendRequest(
        `${MyrAPIEndpoints.SERVICE}/agreement?lang=${langCode}`,
        'GET',
    );
}

export function deleteAccount(data: any, credentials: string) {
    return deleteAccountSvc(data, credentials);
}

export function deleteAccountCancelMember(data: ICancelMembershipRequest, credentials: string) {
    return MyrAPIService.sendRequest(`member`, 'DELETE', data, credentials, 'json');
}

export function updateOptionalConsentStatus(updatedData: any, locale: string) {
    const { serviceUuid, extraParameters } = updatedData;
    const innerlocale = String(locale || localStorage.getItem('userSetLocale'));
    const lang: SupportedLanguage = SupportedLanguageHelper.getSupportLanguage(innerlocale);
    const langCode = PrivacyLocaleFormat[lang] ?? SupportedLanguage.EN;
    return MyrAPIService.sendRequest(
        `${MyrAPIEndpoints.SERVICE}/${serviceUuid}/consent?lang=${langCode}`,
        'PUT',
        extraParameters,
    );
}

export function unlinkSocialProvider(providerId: string) {
    return MyrAPIService.sendRequest(`${MyrAPIEndpoints.SOCIAL_DELETE}/${providerId}`, 'DELETE');
}
